import { render } from "./MovieView.vue?vue&type=template&id=2a591bab&lang=true"
import script from "./MovieView.vue?vue&type=script&lang=js"
export * from "./MovieView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__